const refreshPage = () => {
    window.location.href = window.location.href;
};

export { refreshPage };
